import React, { useState, useEffect } from "react";
import {
  Loader,
  Table,
  Icon,
  Dropdown,
  Button,
  Form,
  Modal,
  Header,
  GridColumn,
  Grid,
  Segment,
  Message,
  Popup,
} from "semantic-ui-react";
import { Productionform, Form as Form1, AuditLog } from "../../../../api";
import { useAuth } from "../../../../hooks";
import {
  hasPermission,
  isAdmin,
  isMaster,
  isEditor,
} from "../../../../utils/checkPermission";
import "./ListProductionForms.scss";
import { formatDateView } from "../../../../utils/formatDate";
import { ProductionForm } from "../ProductionForm";
import { higgs_units, PERIODS } from "../../../../utils";
import { BasicDrawer, ConfirmModal } from "../../../Shared";
import { productionCodes } from "../../../../utils/dataAndFormulas/productionForms";
import { useLanguage } from "../../../../contexts";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Importa el CSS de react-toastify
const _ = require("lodash");

const productionFormController = new Productionform();
const formController = new Form1();
const auditLogController = new AuditLog();

export function ListProductionForms(props) {
  const {
    reload,
    onReload,
    siteSelected,
    yearSelected,
    configFormData,
    setReload,
  } = props;
  const [forms, setForms] = useState([]);
  const [loading, setLoading] = useState(false);
  const { user, accessToken } = useAuth();

  const { language, translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  useEffect(() => {
    (async () => {
      if (yearSelected !== "" && siteSelected) {
        setLoading(true);
        try {
          const response =
            await productionFormController.getProductionFormsBySiteAndYear(
              accessToken,
              siteSelected,
              yearSelected,
            );

          if (response.code === 200 && response.productionForms) {
            setForms(response.productionForms);
          } else {
            setForms([]);
          }
        } catch (error) {
          console.error(error);
          setForms([]);
        } finally {
          setLoading(false);
        }
      }
    })();
  }, [yearSelected, siteSelected, reload]);

  if (loading)
    return (
      <Loader
        active
        inline="centered"
        content="Cargando datos de producción..."
      />
    );
  // if (size(productionforms) === 0) return "No hay ningun formulario de produccón";

  return (
    <div className="list-production-forms">
      <TablePeriods
        data={forms}
        onReload={onReload}
        accessToken={accessToken}
        year={yearSelected}
        site={siteSelected}
        t={t}
        configFormData={configFormData}
        language={language}
        setReload={setReload}
        user={user}
      />
    </div>
  );
}

function TablePeriods(props) {
  const {
    data,
    onReload,
    accessToken,
    year,
    site,
    t,
    configFormData,
    language,
    setReload,
  } = props;

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [modalContent, setModalContent] = useState("");
  const [confirmContent, setConfirmContent] = useState("");
  const [dataDeleted, setDataDelete] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);

  const [rows, setRows] = useState([]);
  const [uniqueFields, setUniqueFields] = useState([]);
  const [selectedUnits, setSelectedUnits] = useState([]);
  const [unitsRecorded, setUnitsRecorded] = useState([]);

  const [configForm, setConfigForm] = useState([]);

  //para mostrar mensaje de alerta
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  //Para el manejo del modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [addFieldType, setAddFieldType] = useState(null); // "VPS" | "VFS" — con qué prefijo se abrió el modal de alta

  // Estado para controlar el modal
  const [selectedPeriod, setSelectedPeriod] = useState(null);

  // Estados para batch edit
  const [batchEditMode, setBatchEditMode] = useState(false);
  const [batchEditedValues, setBatchEditedValues] = useState({});
  const [batchHasChanges, setBatchHasChanges] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [expandedFields, setExpandedFields] = useState({});

  const toggleExpand = (fieldName) => {
    setExpandedFields((prev) => ({ ...prev, [fieldName]: !prev[fieldName] }));
  };

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const baselineOptions = [
    { key: "VPS", value: "VPS", text: `${t("produced")} (VPS)` },
    { key: "VFS", value: "VFS", text: `${t("invoiced")} (VFS)` },
  ];
  const [baselineSelected, setBaselineSelected] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null); // Para guardar el item que se va a eliminar

  // Estado para campos huérfanos (existen en formularios pero no en configuración)
  const [orphanFields, setOrphanFields] = useState([]);
  const [cleaningOrphans, setCleaningOrphans] = useState(false);

  useEffect(() => {
    (async () => {
      if (data) {
        setRows(data);
      } else {
        setRows([]);
      }
    })();
  }, [data]);

  useEffect(() => {
    (async () => {
      try {
        determineFields();
        // Buscar el cambio de base en el array baseline para el año solicitado
      } catch (error) {
        console.error(error);
        setConfigForm([]);
      }
    })();
  }, [configFormData]);

  useEffect(() => {
    (async () => {
      try {
        // Filtrar cambios que sean exactamente del mismo año
        // Solo ejecutar si configForm tiene _id (ya está cargado del servidor)
        if (year && configForm && configForm._id) {
          const baseline = configForm?.baseline || [];
          // Comparar como string para evitar problemas de tipo
          const yearStr = String(year);

          const cambiosDelAnio = baseline.filter(
            (update) => String(update.year) === yearStr,
          );

          // Si hay cambios para este año, usar el más reciente
          if (cambiosDelAnio && cambiosDelAnio.length > 0) {
            const cambioMasReciente = cambiosDelAnio[cambiosDelAnio.length - 1];
            setBaselineSelected(cambioMasReciente.value);
          } else {
            // No hay configuración de baseline para este año: en vez de
            // exigirle al usuario que elija, se guarda "VPS" automáticamente
            // como default (pedido del cliente) -- el desplegable sigue
            // visible y editable por si lo quiere cambiar a Facturado.
            // Nunca pisa un valor ya elegido, solo corre cuando está vacío.
            handleAddEditBaseline("VPS");
          }
        }
      } catch (error) {
        console.error(error);
        setBaselineSelected(null);
      }
    })();
  }, [configForm, year]);

  useEffect(() => {
    (async () => {
      try {
        if (uniqueFields && uniqueFields.length > 0) {
          let fields = uniqueFields.map((field) => field.name);

          const response =
            await productionFormController.getLastUnitFieldsByYear(
              accessToken,
              site,
              year,
              fields,
            );
          if (response.code === 200) {
            //setUnitsRecorded(response.fields);

            let values = {};
            uniqueFields.map((field) => {
              values[field.name] =
                getDataField(field)?.unit || response.fields?.[field.name] || "";
            });

            setUnitsRecorded(values);
          }
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [uniqueFields, site, year, accessToken]);

  // useEffect para advertir al usuario si tiene cambios sin guardar
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (batchHasChanges && batchEditMode) {
        e.preventDefault();
        e.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [batchHasChanges, batchEditMode]);

  // useEffect para atajos de teclado
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === "s" && batchEditMode) {
        e.preventDefault();
        handleBatchSaveChanges();
      }
      if (e.key === "Escape" && batchEditMode) {
        handleBatchCancelEdit();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [batchEditMode, batchEditedValues, batchHasChanges]);

  // useEffect para detectar campos huérfanos (existen en formularios pero no en configuración)
  useEffect(() => {
    if (rows.length > 0 && configForm?.fields?.length > 0) {
      // Obtener todos los nombres de campos configurados
      const configuredFieldNames = new Set(
        configForm.fields.map((f) => f.name),
      );

      // Campos que siempre deben ignorarse (campos del sistema)
      const systemFields = new Set([
        "_id",
        "__v",
        "site",
        "year",
        "period",
        "date",
        "creator_user",
        "created_at",
        "standardized_production",
        "standardized_billing",
      ]);

      // Buscar campos en los formularios que no están en la configuración
      const orphans = new Set();
      rows.forEach((row) => {
        Object.keys(row).forEach((key) => {
          // Si es un campo con estructura de producción (tiene value, code, etc.)
          if (row[key] && typeof row[key] === "object" && row[key].code) {
            if (!configuredFieldNames.has(key) && !systemFields.has(key)) {
              orphans.add(key);
            }
          }
        });
      });

      setOrphanFields(Array.from(orphans));
    } else {
      setOrphanFields([]);
    }
  }, [rows, configForm]);

  // Función para limpiar campos huérfanos
  const handleCleanOrphanFields = async () => {
    if (orphanFields.length === 0) return;

    setCleaningOrphans(true);
    try {
      // Eliminar cada campo huérfano de todos los formularios del año
      for (const fieldName of orphanFields) {
        await productionFormController.updateProductionField(
          accessToken,
          site,
          {
            year: year,
            fieldName: fieldName,
            newValues: { remove: true },
          },
        );
      }

      // Registrar en audit log
      await auditLogController.createAuditLog(accessToken, {
        documentType: "production",
        documentId: site, // Usamos site como referencia ya que afecta múltiples documentos
        changeType: "delete",
        site: site,
        year: year,
        changedBy: props.user._id,
        field: "orphan_fields_cleanup",
        oldValue: { value: orphanFields.join(", "), unit: "campos" },
        newValue: { value: "eliminado", unit: "campos" },
        reason: `Limpieza de ${orphanFields.length} campo(s) huérfano(s): ${orphanFields.join(", ")}`,
      });

      toast.success(
        `Se eliminaron ${orphanFields.length} campo(s) huérfano(s) de los formularios`,
      );
      setOrphanFields([]);
      onReload();
    } catch (error) {
      console.error("Error cleaning orphan fields:", error);
      toast.error("Error al limpiar campos huérfanos");
    } finally {
      setCleaningOrphans(false);
    }
  };

  // Función para abrir el modal con datos del período seleccionado
  const handleOpenModal = (period) => {
    setSelectedPeriod(rows.find((item) => item.period === period));
    //setModalOpen(true);
    onOpenCloseModal();
  };

  // Función para cerrar el modal
  const handleDeleteModal = (period) => {
    const form = rows.find((item) => item.period === period);
    setConfirmContent(
      `${t("delete_dated_production_form")} ${formatDateView(form.date)}`,
    );
    setDataDelete(form);
    onOpenCloseConfirm();
  };

  const openUpdateProductionForm = (period) => {
    //setFieldName(name);
    const form = rows.find((item) => item.period === period);
    setTitleModal(
      `${t("update")} ${t("production_form")}: ${t(form.period)}-${form.year}`,
    );
    setModalContent(
      <ProductionForm
        onClose={onOpenCloseModal}
        onReload={onReload}
        productionForm={form}
        siteSelected={site}
        configFormData={configForm}
        unitsRecorded={unitsRecorded}
      />,
    );
    setShowModal(true);
  };

  const openNewEffluentForm = (period) => {
    setTitleModal("");
    setModalContent(
      <ProductionForm
        onClose={onOpenCloseModal}
        onReload={onReload}
        period={period}
        year={year}
        siteSelected={site}
        configFormData={configForm}
        unitsRecorded={unitsRecorded}
      />,
    );
    setShowModal(true);
  };

  const onDelete = async () => {
    try {
      //TODO: modificar por controlador correspondiente
      const response = await productionFormController.deleteProductionForm(
        accessToken,
        dataDeleted._id,
      );
      if (response.code === 200) {
        setIsSuccess(true);
        setModalMessage("Formulario eliminado correctamente!");
      } else {
        setIsSuccess(false);
        setModalMessage("Error al eliminar el formulario.");
      }

      setModalOpen(true); // Mostrar modal
      setDataDelete(""); // Limpiar datos eliminados
      onOpenCloseConfirm(); // Cerrar el modal de confirmación
      onReload(); // Recargar la información
    } catch (error) {
      console.error(error);
      setIsSuccess(false);
      setModalMessage("Error al eliminar el formulario.");
      setModalOpen(true); // Mostrar modal de error
    }
  };

  const getUnit = (field) => {
    if (unitsRecorded[field]) {
      return unitsRecorded?.[field];
    } else {
      let value = "";
      // Recorrer el array de fields y encontrar el correspondiente a "facturas"
      configFormData &&
        configFormData.fields.forEach((f) => {
          if (f.name === field) {
            value = f.unit; // Salida: "unidad"
          }
        });
      return value;
    }
  };

  // Obtén los nombres de los períodos para las columnas
  const periods = PERIODS;

  // Determinar los campos únicos y si tienen código
  const determineFields = () => {
    const fields = new Set();
    const configFields = [];

    if (
      configFormData &&
      configFormData.fields &&
      configFormData.fields.length > 0
    ) {
      Object.keys(configFormData.fields).forEach((key) => {
        if (
          configFormData.fields &&
          configFormData.fields.some(
            (field) =>
              field.name === configFormData.fields[key].name && field.active,
          )
        ) {
          fields.add({
            code: configFormData.fields[key].code,
            name: configFormData.fields[key].name,
            customName: configFormData.fields[key].customName, // Incluir customName
            isEditable: false,
          });
          configFields.push(configFormData.fields[key]);
        }
      });

      // Asegurar que VPS y VFS siempre estén presentes (campos calculados)
      const hasVPS = Array.from(fields).some((f) => f.code === "VPS");
      const hasVFS = Array.from(fields).some((f) => f.code === "VFS");

      if (!hasVPS) {
        fields.add({
          code: "VPS",
          name: "standardized_production",
          isEditable: false,
        });
        configFields.push({
          code: "VPS",
          name: "standardized_production",
          unit: "Unidades",
          standardized_coefficient: 1,
          active: true,
        });
      }

      if (!hasVFS) {
        fields.add({
          code: "VFS",
          name: "standardized_billing",
          isEditable: false,
        });
        configFields.push({
          code: "VFS",
          name: "standardized_billing",
          unit: "Unidades",
          standardized_coefficient: 1,
          active: true,
        });
      }
    } else {
      Object.keys(productionCodes).forEach((key) => {
        fields.add({
          code: productionCodes[key],
          name: key,
          isEditable: false,
        });
        configFields.push({
          code: productionCodes[key],
          name: key,
          unit: "Unidades",
          standardized_coefficient: 1,
          active: true,
        });
      });
    }

    setConfigForm({ ...configFormData, fields: configFields });

    let final = Array.from(fields).sort((a, b) => {
      if (a.code < b.code) return -1; // Si a.code es menor que b.code, a va antes
      if (a.code > b.code) return 1; // Si a.code es mayor que b.code, b va antes
      return 0; // Si a.code es igual a b.code, no cambia el orden
    });

    setUniqueFields(final);
  };

  const hasDataPeriod = (period) => {
    if (rows) {
      const existsPeriod = rows.some((entry) => entry.period === period);
      return existsPeriod;
    }
    return false;
  };

  const calculateTotalAndAverage = (field, options = {}) => {
    const { applyCoefficient = false } = options;

    const isStandardizedProduction = field === "standardized_production";
    const isStandardizedBilling = field === "standardized_billing";

    const values = rows.map((item) => {
      // Caso 1: VPS -> sumar todos los VP* usando uniqueFields
      if (isStandardizedProduction) {
        let total = 0;
        uniqueFields
          .filter((f) => f.code.startsWith("VP") && !f.code.startsWith("VPS"))
          .forEach((f) => {
            const value = Number(item[f.name]?.value || 0);
            const coef = Number(
              item[f.name]?.standardized_coefficient ||
                getDataField(f)?.standardized_coefficient ||
                1,
            );
            total += value * coef;
          });
        return total;
      }

      // Caso 2: VFS -> sumar todos los VF* usando uniqueFields
      if (isStandardizedBilling) {
        let total = 0;
        uniqueFields
          .filter((f) => f.code.startsWith("VF") && !f.code.startsWith("VFS"))
          .forEach((f) => {
            const value = Number(item[f.name]?.value || 0);
            const coef = Number(
              item[f.name]?.standardized_coefficient ||
                getDataField(f)?.standardized_coefficient ||
                1,
            );
            total += value * coef;
          });
        return total;
      }

      // Caso 3: campo normal
      const value = Number(item[field]?.value || 0);
      const coef = Number(item[field]?.standardized_coefficient || 1);
      return applyCoefficient ? value * coef : value;
    });

    const total = values.reduce((acc, val) => acc + val, 0);
    const average = values.length ? total / values.length : 0;

    return { total, average };
  };

  // Función para enviar los cambios de configuración al backend
  const handleSaveChanges = (updatedFields) => {
    // Decide crear vs actualizar según si la config YA tiene _id (existe en
    // el servidor) -- antes se usaba un estado `isUpdate` que se declaraba en
    // false y nunca se volvía a modificar, así que esto siempre intentaba
    // crear, incluso cuando ya existía una configuración para el sitio,
    // provocando el error "Ya existe un formulario de tipo 'production'...".
    if (updatedFields._id) {
      formController
        .updateForm(accessToken, updatedFields._id, updatedFields)
        .then((response) => {
          if (response.code && response.code === 200) {
            toast.success("Formulario guardado correctamente.");
          }
        })
        .catch((error) => {
          //console.error("Error al guardar la configuración:", error);
          toast.error("Error al guardar el formulario.");
        });
    } else {
      formController
        .createForm(accessToken, updatedFields)
        .then((response) => {
          if (response.code && response.code === 200) {
            toast.success("Formulario guardado correctamente.");
          }
          // alert("Configuración guardada correctamente");
        })
        .catch((error) => {
          toast.error("Error al guardar el formulario.");
          //console.error("Error al guardar la configuración:", error);
          // alert("Error al guardar la configuración");
        });
    }
  };

  const getDataField = (item) => {
    let i = configForm.fields.findIndex((f) => f.code === item.code);
    if (i !== -1) {
      const field = configForm.fields[i];
      // Si la unidad está vacía en configForm, buscar en los documentos existentes
      if (!field.unit || field.unit === "") {
        const docWithUnit = rows.find((row) => row[field.name]?.unit);
        if (docWithUnit && docWithUnit[field.name]?.unit) {
          return { ...field, unit: docWithUnit[field.name].unit };
        }
      }
      return field;
    }
    return null;
  };

  // Funciones para batch edit
  const handleBatchCellChange = (field, period, item, newValue) => {
    const key = `${period}_${field}`;
    setBatchEditedValues((prev) => ({
      ...prev,
      [key]: {
        formId: item?._id || null,
        period: period,
        field,
        value: newValue,
        unit: item?.[field]?.unit || unitsRecorded[field],
        isNew: !item || !item._id,
        year: year,
        site: site,
      },
    }));
    setBatchHasChanges(true);
  };

  const handleBatchSaveChanges = async () => {
    if (!batchHasChanges || Object.keys(batchEditedValues).length === 0) {
      toast.info("No hay cambios para guardar");
      return;
    }
    setIsSaving(true);
    try {
      const updates = {};
      const creates = [];
      Object.entries(batchEditedValues).forEach(([key, change]) => {
        if (change.isNew) {
          creates.push({
            period: change.period,
            year: change.year,
            site: change.site,
            field: change.field,
            value: change.value,
            unit: change.unit,
          });
        } else {
          updates[key] = {
            formId: change.formId,
            field: change.field,
            value: change.value,
            unit: change.unit,
          };
        }
      });
      const response =
        await productionFormController.batchUpdateProductionForms(accessToken, {
          updates,
          creates,
          site,
          year,
          creatorUser: props.user._id,
        });
      if (response.code === 200) {
        toast.success(
          `✅ ${response.updated || 0} formularios actualizados, ${response.created || 0} creados`,
        );
        setBatchEditedValues({});
        setBatchHasChanges(false);
        setBatchEditMode(false);
        onReload();
      } else {
        toast.error(response.msg || "Error al guardar los cambios");
      }
    } catch (error) {
      console.error("Error saving changes:", error);
      toast.error("Error al guardar los cambios");
    } finally {
      setIsSaving(false);
    }
  };

  const handleBatchCancelEdit = () => {
    if (batchHasChanges) {
      if (window.confirm("¿Descartar cambios sin guardar?")) {
        setBatchEditedValues({});
        setBatchHasChanges(false);
        setBatchEditMode(false);
      }
    } else {
      setBatchEditMode(false);
    }
  };

  const toggleBatchEditMode = () => {
    if (batchEditMode && batchHasChanges) {
      if (window.confirm("Tienes cambios sin guardar. ¿Deseas descartarlos?")) {
        setBatchEditedValues({});
        setBatchHasChanges(false);
        setBatchEditMode(false);
      }
    } else {
      setBatchEditMode(!batchEditMode);
    }
  };

  // Función para manejar la apertura del modal para agregar o editar
  const openModal = (item = null, type) => {
    if (item) {
      let i = configForm.fields.findIndex((f) => f.code === item.code);
      setFormData(configForm.fields[i]);
      setEditMode(true);
      setEditingIndex(i);
    } else {
      const newCode =
        type === "VPS"
          ? `VP${
              uniqueFields.filter(
                (f) => f.code.includes("VP") && !f.code.includes("VPS"),
              ).length + 1
            }`
          : `VF${
              uniqueFields.filter(
                (f) => f.code.includes("VF") && !f.code.includes("VFS"),
              ).length + 1
            }`;
      setFormData({
        code: newCode,
        name: "",
        unit: "",
        standardized_coefficient: 1,
      });
      setEditMode(false);
      setEditingIndex(null);
      setAddFieldType(type);
    }
    setIsModalOpen(true);
  };

  // Función para manejar el cierre del modal
  const closeModal = () => {
    setIsModalOpen(false);
    setFormData({
      code: "",
      name: "",
      unit: "Unidades",
      standardized_coefficient: 1,
    });
  };

  // Manejar cambios en el formulario
  const handleInputChange = (e, { name, value }) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleDropdownChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Función para agregar un nuevo registro. Usa el endpoint atómico del
  // servidor (calcula el código y lo empuja en una sola operación) en vez de
  // guardar el documento entero con la copia local de 'fields', que podía
  // pisar altas hechas por otra pestaña/usuario justo antes.
  const handleAdd = async () => {
    try {
      const prefix = addFieldType === "VPS" ? "VP" : "VF";
      const response = await formController.addField(accessToken, configForm._id, {
        prefix,
        name: formData.name,
        unit: formData.unit,
        standardized_coefficient: formData.standardized_coefficient,
        customName: formData.customName,
      });
      if (response.code === 200 && response.dataStore) {
        setConfigForm(response.dataStore);
        toast.success("Formulario guardado correctamente.");
      }
      setReload(true);
      closeModal();
    } catch (error) {
      console.error("Error adding data", error);
      toast.error("Error al agregar el campo.");
    }
  };

  // Agrega la entrada de línea base (VFS/VPS) para este año de forma atómica
  // en el servidor (crea el formulario si todavía no existe) en vez de
  // guardar el documento entero con la copia local de 'baseline', que podía
  // pisar altas hechas por otra pestaña/usuario justo antes.
  const handleAddEditBaseline = async (value) => {
    try {
      setBaselineSelected(value);
      const response = await formController.addFormBaseline(
        accessToken,
        configForm.module || "production",
        site,
        { value, year }
      );
      if (response.code === 200 && response.dataStore) {
        setConfigForm(response.dataStore);
      }
      setReload(true);
      closeModal();
    } catch (error) {
      console.error("Error adding data", error);
    }
  };

  // Función para editar un registro existente
  // const handleEdit = async () => {
  //   try {
  //     const updatedData = [...configForm.fields];
  //     updatedData[editingIndex] = formData;
  //     //setConfigForm({ ...configForm, fields: updatedData });
  //     handleSaveChanges({ ...configForm, fields: updatedData });
  //     setReload(true);
  //     closeModal();
  //   } catch (error) {
  //     console.error("Error editing data", error);
  //   }
  // };

  const handleEdit = async () => {
    try {
      const updatedData = [...configForm.fields];
      const oldField = updatedData[editingIndex];
      const newField = formData;

      // Detectar cambio de coeficiente
      const coefChanged =
        oldField.standardized_coefficient !== newField.standardized_coefficient;

      updatedData[editingIndex] = newField;

      // Guardar cambios en el formulario base
      handleSaveChanges({ ...configForm, fields: updatedData });
      setReload(true);
      closeModal();

      // Si cambió el coeficiente → actualiza en todos los Production del año
      if (coefChanged) {
        // Actualizar en todos los documentos del año
        await productionFormController.updateProductionField(
          accessToken,
          site,
          {
            year: year,
            fieldName: newField.name,
            newValues: {
              standardized_coefficient: newField.standardized_coefficient,
              unit: newField.unit,
              code: newField.code,
              customName: newField.customName, // Incluir customName en la actualización
            },
          },
        );

        toast.success(
          `Coeficiente de ${newField.name} actualizado en todos los documentos del año ${year}`,
        );
        onReload();
      }
    } catch (error) {
      console.error("Error editing data", error);
      toast.error("Error al actualizar el campo");
    }
  };

  // Función para eliminar un registro
  const handleDelete = async (index) => {
    try {
      const updatedData = [...configForm.fields].filter(
        (i) => i.code !== index.code,
      );
      //setConfigForm({ ...configForm, fields: updatedData });
      handleSaveChanges({ ...configForm, fields: updatedData });
      setReload(true);
      // setData(updatedData);
    } catch (error) {
      console.error("Error deleting data", error);
    }
  };

  const [errors, setErrors] = useState({
    code: false,
    name: false,
    unit: false,
    standardized_coefficient: false,
  });

  // Función de validación
  const validateForm = () => {
    let isValid = true;
    if (!formData.code) {
      toast.error("El campo Código es requerido.");
      isValid = false;
    }
    if (!formData.name) {
      toast.error("El campo Concepto es requerido.");
      isValid = false;
    }
    if (!formData.unit) {
      toast.error("El campo Unidad es requerido.");
      isValid = false;
    }
    // if (!formData.standardized_coefficient) {
    //   toast.error("El campo Coeficiente estandarizado es requerido.");
    //   isValid = false;
    // }
    return isValid;
  };

  const handleSubmit = () => {
    // Validar formulario antes de enviar
    if (validateForm()) {
      if (editMode) {
        handleEdit();
      } else {
        handleAdd();
      }
    }
  };

  // Función para abrir el modal de confirmación
  const openConfirm = (index) => {
    setSelectedItem(index); // Guardamos el ítem que se va a eliminar
    setOpen(true); // Abrimos el modal
  };

  // Función para cerrar el modal de confirmación
  const closeConfirm = () => {
    setOpen(false);
    setSelectedItem(null); // Limpiar el ítem seleccionado
  };

  // Función para eliminar el registro
  const handleDeleteConfirm = async () => {
    try {
      // Filtramos el registro que queremos eliminar
      const updatedData = [...configForm.fields].filter(
        (i) => i.code !== selectedItem.code,
      );
      handleSaveChanges({ ...configForm, fields: updatedData });
      // Eliminar el campo de todos los formularios del año
      await productionFormController.updateProductionField(accessToken, site, {
        year: year,
        fieldName: selectedItem.name,
        newValues: { remove: true },
      });
      toast.success(
        "Campo eliminado de la configuración y de todos los formularios del año",
      );
      setReload(true); // Recargar los datos después de la eliminación
      closeConfirm(); // Cerrar el modal de confirmación
    } catch (error) {
      console.error("Error deleting data", error);
      toast.error("Error al eliminar el campo");
    }
  };

  return (
    <>
      {/* Alerta de campos huérfanos - Solo visible para Master o Admin */}
      {orphanFields.length > 0 &&
        (isMaster(props.user.role) || isAdmin(props.user.role)) && (
          <Message warning>
            <Message.Header>
              <Icon name="warning sign" />
              Se detectaron campos huérfanos en los formularios
            </Message.Header>
            <p>
              Los siguientes campos existen en los formularios pero ya no están
              en la configuración: <strong>{orphanFields.join(", ")}</strong>
            </p>
            <Button
              color="orange"
              size="small"
              onClick={handleCleanOrphanFields}
              loading={cleaningOrphans}
              disabled={cleaningOrphans}
            >
              <Icon name="trash" />
              Limpiar campos huérfanos ({orphanFields.length})
            </Button>
          </Message>
        )}

      {/* Controles de edición batch */}
      {(isMaster(props.user.role) || isAdmin(props.user.role) || isEditor(props.user.role)) && (
      <div className="batch-actions">
        {!batchEditMode ? (
          <Popup
            content={t("enable_multiple_edit")}
            trigger={
              <Button
                icon
                //labelPosition="left"
                onClick={toggleBatchEditMode}
                disabled={isSaving || rows.length === 0}
                className="batch-btn primary"
              >
                <Icon name="edit" />
                {/* Editar Multiples Periodos */}
              </Button>
            }
          />
        ) : (
          <>
            <Button
              icon
              labelPosition="left"
              onClick={handleBatchSaveChanges}
              disabled={!batchHasChanges || isSaving}
              loading={isSaving}
              className="batch-btn success"
            >
              <Icon name="save" />
              {t("save")}
            </Button>

            <Button
              icon
              labelPosition="left"
              onClick={handleBatchCancelEdit}
              disabled={isSaving}
              className="batch-btn cancel"
            >
              <Icon name="cancel" />
              {t("cancel")}
            </Button>

            {batchHasChanges && (
              <Message compact warning size="small" className="batch-warning">
                <Icon name="warning sign" />
                Hay cambios sin guardar. Presiona Ctrl+S para guardar o Esc para
                cancelar.
              </Message>
            )}
          </>
        )}
      </div>
      )}

      {/* ---- Sección Volumen ---- */}
      <div className="production-section-wrapper">
        <div className="production-section-header">
          <span className="production-section-title">Volumen</span>
        </div>
        <Button
          icon
          className="production-section-add-btn"
          onClick={() => openModal(null, "VPS")}
          primary
        >
          <Icon name="plus" />
        </Button>
      </div>
      <div className="list-production-forms__table-wrapper">
        <Table className="production-table" unstackable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell
                textAlign="center"
                className="sticky-col-1 pill-left-start"
              >
                {t("code")}
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="center" className="sticky-col-2">
                {t("concept")}
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="center" className="pill-left-end">
                {t("units")}
              </Table.HeaderCell>
              <Table.HeaderCell className="pill-gap" />
              <Table.HeaderCell
                colSpan="3"
                textAlign="center"
                className="pill-right"
              >
                {t("report_period")} {year}
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {uniqueFields
              //.filter((item) => item.code.startsWith("VP")) se comento temporalmente     
                .filter((item) => item.code.startsWith("VP") && !item.code.startsWith("VPS"))//se reemplazo por esta linea para mostrar solo los campos de producción sin estandarizar en esta sección, los estandarizados se muestran al final con su propio código VPS
              .map((field) => {
                const isStandardized = field.code.startsWith("VPS");
                const isExpanded = expandedFields[field.name];
                const totalVal = isStandardized
                  ? calculateTotalAndAverage(field.name, {
                      applyCoefficient: true,
                    }).total
                  : calculateTotalAndAverage(field.name).total;
                const avgVal = isStandardized
                  ? calculateTotalAndAverage(field.name, {
                      applyCoefficient: true,
                    }).average.toFixed(2)
                  : calculateTotalAndAverage(field.name).average.toFixed(2);
                return (
                  <React.Fragment key={field.name}>
                    {/* Fila resumen */}
                    <Table.Row>
                      <Table.Cell className="sticky-col-1 pill-left-start">
                        {field.code}
                      </Table.Cell>
                      <Table.Cell className="sticky-col-2">
                        {field.customName || t(field.name)}
                      </Table.Cell>
                      <Table.Cell className="pill-left-end">
                        {getDataField(field)?.unit && getDataField(field)?.unit !== "unidades" ? getDataField(field)?.unit : null}
                      </Table.Cell>
                      <Table.Cell className="pill-gap" />
                      <Table.Cell colSpan="3" className="pill-right">
                        <div className="summary-flex">
                          <span className="summary-item">
                            Total: <strong>{totalVal}</strong>
                          </span>
                          <span className="summary-item">
                            Promedio: <strong>{avgVal}</strong>
                          </span>
                          <Button
                            icon
                            size="tiny"
                            className="expand-btn"
                            onClick={() => toggleExpand(field.name)}
                          >
                            <Icon
                              name={isExpanded ? "chevron up" : "chevron down"}
                            />
                          </Button>
                          <Button
                            icon
                            size="mini"
                            onClick={() => openModal(field)}
                          >
                            <Icon name="edit" />
                          </Button>
                          {!productionCodes[field.name] && (
                            <Button
                              icon
                              negative
                              size="mini"
                              onClick={() => openConfirm(field)}
                            >
                              <Icon name="delete" />
                            </Button>
                          )}
                        </div>
                      </Table.Cell>
                    </Table.Row>
                    {/* Filas expandidas */}
                    {isExpanded && (
                      <>
                        <Table.Row className="months-header-row">
                          <Table.Cell
                            colSpan="7"
                            style={{ padding: 0 }}
                            className="months-full-row"
                          >
                            <div className="months-flex-container">
                              {periods.map((period) => (
                                <div
                                  key={period}
                                  className="month-flex-cell month-flex-header"
                                >
                                  {t(period).slice(0, 3)}
                                  {hasDataPeriod(period) ? (
                                    <Dropdown
                                      inline
                                      size="tiny"
                                      icon="ellipsis vertical"
                                      floating
                                      className="icon"
                                    >
                                      <Dropdown.Menu>
                                        <Dropdown.Item
                                          text={t("edit")}
                                          icon={
                                            <Icon
                                              name="edit"
                                              style={{ color: "gray" }}
                                            />
                                          }
                                          onClick={() =>
                                            openUpdateProductionForm(period)
                                          }
                                        />
                                        <Dropdown.Item
                                          text={t("delete")}
                                          icon={
                                            <Icon
                                              name="trash"
                                              style={{ color: "red" }}
                                            />
                                          }
                                          onClick={() =>
                                            handleDeleteModal(period)
                                          }
                                        />
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  ) : (
                                    <Dropdown
                                      icon="ellipsis vertical"
                                      floating
                                      size="tiny"
                                      className="icon"
                                      exact="true"
                                    >
                                      <Dropdown.Menu>
                                        {isAdmin(props.user.role) ||
                                        isEditor(props.user.role) ||
                                        isMaster(props.user.role) ? (
                                          <Dropdown.Item
                                            text={t("load_data")}
                                            icon={
                                              <Icon
                                                name="plus"
                                                style={{ color: "black" }}
                                              />
                                            }
                                            onClick={() =>
                                              openNewEffluentForm(period)
                                            }
                                          />
                                        ) : null}
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  )}
                                </div>
                              ))}
                            </div>
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row className="months-data-row">
                          <Table.Cell
                            colSpan="7"
                            style={{ padding: 0 }}
                            className="months-full-row"
                          >
                            <div className="months-flex-container">
                              {periods.map((period) => {
                                const item = rows.find(
                                  (d) => d.period === period,
                                );
                                let cellContent;
                                if (isStandardized) {
                                  const totalStd = uniqueFields
                                    .filter(
                                      (f) =>
                                        f.code.startsWith("VP") &&
                                        !f.code.startsWith("VPS"),
                                    )
                                    .reduce((acc, f) => {
                                      const value = item?.[f.name]?.value || 0;
                                      const coef =
                                        item?.[f.name]
                                          ?.standardized_coefficient ||
                                        getDataField(f)
                                          ?.standardized_coefficient ||
                                        1;
                                      return acc + value * coef;
                                    }, 0);
                                  cellContent = totalStd.toFixed(2);
                                } else if (batchEditMode) {
                                  const editKey = `${period}_${field.name}`;
                                  const isEdited =
                                    batchEditedValues[editKey] !== undefined;
                                  const displayVal = isEdited
                                    ? batchEditedValues[editKey].value
                                    : item?.[field.name]?.value || "";
                                  cellContent = (
                                    <input
                                      type="number"
                                      step="0.01"
                                      value={displayVal}
                                      onChange={(e) =>
                                        handleBatchCellChange(
                                          field.name,
                                          period,
                                          item,
                                          parseFloat(e.target.value) || 0,
                                        )
                                      }
                                      style={{
                                        width: "100%",
                                        height: "30px",
                                        border: isEdited
                                          ? "2px solid #fbc02d"
                                          : "1px solid #ccc",
                                        borderRadius: "4px",
                                        padding: "3px 6px",
                                        fontSize: "11px",
                                        textAlign: "right",
                                        backgroundColor: isEdited
                                          ? "#fff9c4"
                                          : "white",
                                        MozAppearance: "textfield",
                                        appearance: "textfield",
                                      }}
                                      placeholder="-"
                                    />
                                  );
                                } else {
                                  cellContent =
                                    item?.[field.name]?.value || "-";
                                }
                                return (
                                  <div
                                    key={period}
                                    className="month-flex-cell month-flex-data"
                                  >
                                    {cellContent}
                                  </div>
                                );
                              })}
                            </div>
                          </Table.Cell>
                        </Table.Row>
                      </>
                    )}
                  </React.Fragment>
                );
              })}
          </Table.Body>
        </Table>
      </div>

      {/* ---- Sección Facturación ---- */}
      <div className="production-section-wrapper">
        <div className="production-section-header">
          <span className="production-section-title">Facturación</span>
        </div>
        <Button
          icon
          className="production-section-add-btn"
          onClick={() => openModal(null, "VFS")}
          primary
        >
          <Icon name="plus" />
        </Button>
      </div>
      <div className="list-production-forms__table-wrapper">
        <Table className="production-table" unstackable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell
                textAlign="center"
                className="sticky-col-1 pill-left-start"
              >
                {t("code")}
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="center" className="sticky-col-2">
                {t("concept")}
              </Table.HeaderCell>
              <Table.HeaderCell textAlign="center" className="pill-left-end">
                {t("units")}
              </Table.HeaderCell>
              <Table.HeaderCell className="pill-gap" />
              <Table.HeaderCell
                colSpan="3"
                textAlign="center"
                className="pill-right"
              >
                {t("report_period")} {year}
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {uniqueFields
              //.filter((item) => item.code.startsWith("VF")) se coemnta temporalmente
                .filter((item) => item.code.startsWith("VF") && !item.code.startsWith("VFS"))//se reemplazo por esta linea para mostrar solo los campos de facturación sin estandarizar en esta sección, los estandarizados se muestran al final con su propio código VFS
              .map((field) => {
                const isStandardized = field.code.startsWith("VFS");
                const isExpanded = expandedFields[field.name];
                const totalVal = isStandardized
                  ? calculateTotalAndAverage(field.name, {
                      applyCoefficient: true,
                    }).total
                  : calculateTotalAndAverage(field.name).total;
                const avgVal = isStandardized
                  ? calculateTotalAndAverage(field.name, {
                      applyCoefficient: true,
                    }).average.toFixed(2)
                  : calculateTotalAndAverage(field.name).average.toFixed(2);
                return (
                  <React.Fragment key={field.name}>
                    {/* Fila resumen */}
                    <Table.Row>
                      <Table.Cell className="sticky-col-1 pill-left-start">
                        {field.code}
                      </Table.Cell>
                      <Table.Cell className="sticky-col-2">
                        {field.customName || t(field.name)}
                      </Table.Cell>
                      <Table.Cell className="pill-left-end">
                        {getDataField(field)?.unit && getDataField(field)?.unit !== "unidades" ? getDataField(field)?.unit : null}
                      </Table.Cell>
                      <Table.Cell className="pill-gap" />
                      <Table.Cell colSpan="3" className="pill-right">
                        <div className="summary-flex">
                          <span className="summary-item">
                            Total: <strong>{totalVal}</strong>
                          </span>
                          <span className="summary-item">
                            Promedio: <strong>{avgVal}</strong>
                          </span>
                          <Button
                            icon
                            size="tiny"
                            className="expand-btn"
                            onClick={() => toggleExpand(field.name)}
                          >
                            <Icon
                              name={isExpanded ? "chevron up" : "chevron down"}
                            />
                          </Button>
                          <Button
                            icon
                            size="mini"
                            onClick={() => openModal(field)}
                          >
                            <Icon name="edit" />
                          </Button>
                          {!productionCodes[field.name] && (
                            <Button
                              icon
                              negative
                              size="mini"
                              onClick={() => openConfirm(field)}
                            >
                              <Icon name="delete" />
                            </Button>
                          )}
                        </div>
                      </Table.Cell>
                    </Table.Row>
                    {/* Filas expandidas */}
                    {isExpanded && (
                      <>
                        <Table.Row className="months-header-row">
                          <Table.Cell
                            colSpan="7"
                            style={{ padding: 0 }}
                            className="months-full-row"
                          >
                            <div className="months-flex-container">
                              {periods.map((period) => (
                                <div
                                  key={period}
                                  className="month-flex-cell month-flex-header"
                                >
                                  {t(period).slice(0, 3)}
                                  {hasDataPeriod(period) ? (
                                    <Dropdown
                                      inline
                                      size="tiny"
                                      icon="ellipsis vertical"
                                      floating
                                      className="icon"
                                    >
                                      <Dropdown.Menu>
                                        <Dropdown.Item
                                          text={t("edit")}
                                          icon={
                                            <Icon
                                              name="edit"
                                              style={{ color: "gray" }}
                                            />
                                          }
                                          onClick={() =>
                                            openUpdateProductionForm(period)
                                          }
                                        />
                                        <Dropdown.Item
                                          text={t("delete")}
                                          icon={
                                            <Icon
                                              name="trash"
                                              style={{ color: "red" }}
                                            />
                                          }
                                          onClick={() =>
                                            handleDeleteModal(period)
                                          }
                                        />
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  ) : (
                                    <Dropdown
                                      icon="ellipsis vertical"
                                      floating
                                      size="tiny"
                                      className="icon"
                                      exact="true"
                                    >
                                      <Dropdown.Menu>
                                        {isAdmin(props.user.role) ||
                                        isEditor(props.user.role) ||
                                        isMaster(props.user.role) ? (
                                          <Dropdown.Item
                                            text={t("load_data")}
                                            icon={
                                              <Icon
                                                name="plus"
                                                style={{ color: "black" }}
                                              />
                                            }
                                            onClick={() =>
                                              openNewEffluentForm(period)
                                            }
                                          />
                                        ) : null}
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  )}
                                </div>
                              ))}
                            </div>
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row className="months-data-row">
                          <Table.Cell
                            colSpan="7"
                            style={{ padding: 0 }}
                            className="months-full-row"
                          >
                            <div className="months-flex-container">
                              {periods.map((period) => {
                                const item = rows.find(
                                  (d) => d.period === period,
                                );
                                let cellContent;
                                if (isStandardized) {
                                  const totalStd = uniqueFields
                                    .filter(
                                      (f) =>
                                        f.code.startsWith("VF") &&
                                        !f.code.startsWith("VFS"),
                                    )
                                    .reduce((acc, f) => {
                                      const value = item?.[f.name]?.value || 0;
                                      const coef =
                                        item?.[f.name]
                                          ?.standardized_coefficient ||
                                        getDataField(f)
                                          ?.standardized_coefficient ||
                                        1;
                                      return acc + value * coef;
                                    }, 0);
                                  cellContent = totalStd.toFixed(2);
                                } else if (batchEditMode) {
                                  const editKey = `${period}_${field.name}`;
                                  const isEdited =
                                    batchEditedValues[editKey] !== undefined;
                                  const displayVal = isEdited
                                    ? batchEditedValues[editKey].value
                                    : item?.[field.name]?.value || "";
                                  cellContent = (
                                    <input
                                      type="number"
                                      step="0.01"
                                      value={displayVal}
                                      onChange={(e) =>
                                        handleBatchCellChange(
                                          field.name,
                                          period,
                                          item,
                                          parseFloat(e.target.value) || 0,
                                        )
                                      }
                                      style={{
                                        width: "100%",
                                        height: "30px",
                                        border: isEdited
                                          ? "2px solid #fbc02d"
                                          : "1px solid #ccc",
                                        borderRadius: "4px",
                                        padding: "3px 6px",
                                        fontSize: "11px",
                                        textAlign: "right",
                                        backgroundColor: isEdited
                                          ? "#fff9c4"
                                          : "white",
                                        MozAppearance: "textfield",
                                        appearance: "textfield",
                                      }}
                                      placeholder="-"
                                    />
                                  );
                                } else {
                                  cellContent =
                                    item?.[field.name]?.value || "-";
                                }
                                return (
                                  <div
                                    key={period}
                                    className="month-flex-cell month-flex-data"
                                  >
                                    {cellContent}
                                  </div>
                                );
                              })}
                            </div>
                          </Table.Cell>
                        </Table.Row>
                      </>
                    )}
                  </React.Fragment>
                );
              })}
          </Table.Body>
        </Table>
      </div>
      <Segment className="baseline-segment">
        <Grid columns={2}>
          <GridColumn width={5}>
            <Header as="h4" style={{ marginTop: "8px" }}>
              Quiere utilizar como linea base el volumen producido o el
              facturado?
            </Header>
          </GridColumn>
          <GridColumn>
            <Dropdown
              className="baseline-dropdown"
              fluid
              selection
              options={baselineOptions}
              onChange={(_, data) => {
                handleAddEditBaseline(data.value);
              }}
              value={baselineSelected}
            />
          </GridColumn>
        </Grid>
      </Segment>
      <ToastContainer
        position="top-right"
        autoClose={1800}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {/* Modal para mostrar detalles del período seleccionado */}
      <Modal open={isModalOpen} onClose={closeModal} size="tiny" className="production-item-modal">
        {/* <Header
          content={editMode ? "Editar Registro" : "Agregar Nuevo Registro"}
        /> */}
        <Modal.Content>
          <Form className="production-item-form">
            {/* {errors.code && <Message error content="El campo Código es requerido." />} */}
            <Form.Input
              label={<label><span style={{ color: "red", marginRight: 4 }}>*</span>Código</label>}
              name="code"
              value={formData.code}
              onChange={handleInputChange}
              disabled={!productionCodes[formData.name] ? false : true}
              style={{ opacity: 1 }} // Asegura que no tenga opacidad reducida
            />
            {/* {errors.name && <Message error content="El campo Concepto es requerido." />} */}
            <Form.Input
              label={<label><span style={{ color: "red", marginRight: 4 }}>*</span>Concepto</label>}
              name="name"
              value={t(formData.name)}
              onChange={handleInputChange}
              disabled={!productionCodes[formData.name] ? false : true}
              style={{ opacity: 1 }} // Asegura que no tenga opacidad reducida
            />
            {/* Campo para nombre personalizado (solo para VP1 y VF1) */}
            {(formData.name === "production_volume" ||
              formData.name === "billing_volume") && (
              <Form.Input
                label="Nombre personalizado (opcional)"
                name="customName"
                placeholder={t(formData.name)}
                value={formData.customName || ""}
                onChange={handleInputChange}
              />
            )}
            {/* {errors.unit && <Message error content="El campo Unidad es requerido." />} */}
            <Form.Dropdown
              label={<label><span style={{ color: "red", marginRight: 4 }}>*</span>Unidad</label>}
              name="unit"
              value={formData.unit}
              options={higgs_units.map((ds) => {
                return {
                  key: ds.key,
                  text: ds.name,
                  value: ds.value,
                };
              })}
              selection
              onChange={(_, data) => handleDropdownChange("unit", data.value)}
            />
            {/* {errors.standardized_coefficient && <Message error content="El campo Coeficiente estandarizado es requerido." />} */}
            {/* <Form.Input
              label="Coeficiente estandarizado"
              name="standardized_coefficient"
              value={formData.standardized_coefficient}
              onChange={handleInputChange}
            /> */}
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            //onClick={editMode ? handleEdit : handleAdd}
            onClick={handleSubmit}
            primary
            //labelPosition="right"
            // icon="checkmark"
            content={t("save")}
          />
          <Button onClick={closeModal} secondary>
            {t("cancel")}
          </Button>
        </Modal.Actions>
      </Modal>

      <Modal open={open} size="tiny" onClose={closeConfirm}>
        <Modal.Header>{t("delete")}</Modal.Header>
        <Modal.Content style={{ padding: "2rem 2rem 1.5rem" }}>
          <p>¿Estás seguro de que deseas eliminar este registro?</p>
        </Modal.Content>
        <Modal.Actions>
          <Button primary onClick={handleDeleteConfirm}>{t("accept")}</Button>
          <Button secondary onClick={closeConfirm}>{t("cancel")}</Button>
        </Modal.Actions>
      </Modal>

      <BasicDrawer show={showModal} close={onOpenCloseModal}>
        {modalContent}
      </BasicDrawer>
      <ConfirmModal
        open={showConfirm}
        title={t("delete")}
        content={confirmContent}
        onConfirm={onDelete}
        onCancel={onOpenCloseConfirm}
        danger
      />

      <ConfirmModal
        open={modalOpen}
        icon={<Icon name={isSuccess ? "check circle outline" : "warning sign"} color={isSuccess ? "green" : "red"} />}
        title={isSuccess ? "Éxito" : "Error"}
        content={modalMessage}
        onCancel={() => setModalOpen(false)}
        cancelText="Cerrar"
      />
    </>
  );
}
